import React, { FC, useMemo } from 'react'
import { classnames } from '@dt/fe-utils'
import { Icon } from '@cps'
import { menuMobx } from 'restaurant'

import './index.scss'
import { observer } from 'mobx-react'

// interface
interface IProps {
  cnt?: number;
  no?: string;
  className?: string;
  /** 来源 菜单 | 套餐 | 规格 ｜ 加料 */
  from?: 'menu' | 'combo' | 'scale' | 'modify';
  /** 是否展示 */
  show: boolean;
  style?: { [key: string]: string | number };
}

const SoldoutFoldBar: FC<IProps> = ({
  cnt,
  no = '',
  className = '',
  from = 'menu',
  show = false,
  style = {},
}) => {
  const wrapId = `soldout_bar_${no}`
  const handleChange = () => {
    if (!no) return
    menuMobx.setFoldSoldoutMap(no)
  }
  const isProduct = ['menu', 'combo'].includes(from)
  // const isScale = ['scale', 'modify'].includes(from)
  /** 已经开启隐藏售罄就不展示 */
  if (isProduct && (menuMobx.isOpenSoldout || !menuMobx.openFoldSoldout)) return null
  return (
    <div
      className={classnames('soldout-fold-bar-container', className, `soldout${no}`, {
        show
      })}
      id={`waterfallproduct${wrapId}`}
      data-cypid={`soldoutBar_${no}`}
      style={style}
      onClick={handleChange}
    >
      {
        show ? (
          <span className='txt'>{i18n.t('menu.soldoutFoldUp')}</span>
        ) : (
          <span className='txt'>{i18n.t(`menu.soldoutFoldDown_${from}`, { cnt })}</span>
        )
      }
      {isProduct && <Icon name={show ? 'chevron-up' : 'chevron-down'} />}
    </div>
  )
}

export default observer(SoldoutFoldBar)
